var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { RadioGroup } from 'hx-ui';
import { useFormContext } from 'react-hook-form';
import { GenderItem } from './gender.component';
export function GenderSelectContent() {
    var control = useFormContext().control;
    return (_jsxs(RadioGroup, __assign({ control: control, rules: {
            required: 'Please select an option.',
        }, name: "gender-at-birth", className: "grid place-items-start gap-1 md:gap-4 md:gap-x-10 md:p-4 sm:grid-cols-2 text-lg md:text-xl" }, { children: [_jsx(GenderItem, { value: 'male', label: 'Male' }), _jsx(GenderItem, { value: 'female', label: 'Female' })] })));
}
